export const Colors = {
	white: "#FFFFFF",
	mediumDarkNavy: "#0a192f",
	themeFontColor: "#64FFDA",
	footerColor: "#020c1b",
	nameColor: "#e6f1ff",
	fontColor: "#8892b0",
	motoColor: "#8892b0",
	shortDescriptionColor: "#8892b0",
	iconColor: "#a8b2d1",
	lineColor: "#2d3952",
	projectBox: "#172a45",
	featProject: "#1d4752",
	imageCoverColor: "#5ee2cb",
};

export default Colors;
